"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactRedux = require("react-redux");

var _CustomerData = require("../../components/steps/CustomerData");

var _CustomerData2 = _interopRequireDefault(_CustomerData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapStateToProps(state, ownProps) {
  var formData = state.formData;
  var firstName = formData.firstName,
      lastName = formData.lastName,
      company = formData.company,
      email = formData.email,
      phone = formData.phone,
      message = formData.message,
      isCustomer = formData.isCustomer,
      reminderMail = formData.reminderMail,
      reminderSMS = formData.reminderSMS;
  return _extends({
    firstName: firstName,
    lastName: lastName,
    company: company,
    email: email,
    phone: phone,
    message: message,
    isCustomer: isCustomer,
    reminderMail: reminderMail,
    reminderSMS: reminderSMS
  }, ownProps);
}

var CustomerDataContainer = (0, _reactRedux.connect)(mapStateToProps)(_CustomerData2.default);
exports.default = CustomerDataContainer;